// Module
var code = "<a ui-sref=\"FundsSso({\n      spendingAccountId: FundsSsoLink.spendingAccountId,\n      partnerId: FundsSsoLink.partnerId\n    })\" target=\"_blank\" rel=\"noopener noreferrer\" ng-click=\"FundsSsoLink.trackClick()\" ng-transclude> </a> ";
// Exports
var _module_exports = code;;
var path = '@collectivehealth/frontend-member-v2/components/fundsSsoLink/fundsSsoLink.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;